<template>
  <b-message
    :type="type"
    :closable="closable"
    :has-icon="hasIcon"
    :size="size"
    :aria-close-label="ariaCloseLabel"
    @close="onClose"
  >
    <template #header v-if="$slots.header">
      <slot name="header" />
    </template>
    <slot />
  </b-message>
</template>

<script>
export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'MessageView',
  emits: ['close'],
  slotsDefinition: {
    header: {}
  },
  props: {
    type: {
      type: String
    },
    closable: {
      type: Boolean,
      default: true
    },
    hasIcon: {
      type: Boolean,
      default: false
    },
    size: {
      type: String
    },
    ariaCloseLabel: {
      type: String
    }
  },
  methods: {
    onClose(...args) {
      this.$emit('close', ...args);
    }
  }
};
</script>
